import { Injectable } from '@angular/core';
import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
import { CompanyGroupResponse } from '../models';
import { PushNotificationConfiguration } from '@symphony-solo/domain/push-notifications/src/lib/models';
import { PushNotificationsService } from '@symphony-solo/domain/push-notifications/src/lib/services';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  public config: AppConfiguration = {
    companyGuid: null,
    scanditLicense: '',
    sharedSecret: null,
  };
  public pushNotificationConfig: PushNotificationConfiguration = {
    firebaseProjectNumber: null,
    oneSignalAppId: null,
  }
  public Company: CompanyGroupResponse;

  constructor(private pushNotificationsService: PushNotificationsService) {}

  public setConfig(response: any) {
    this.config.companyGuid = response.companyGuid;
    this.config.scanditLicense = '';
    this.config.sharedSecret = response.sharedSecret;
    this.pushNotificationConfig.firebaseProjectNumber = response?.firebaseProjectNumber;
    this.pushNotificationConfig.oneSignalAppId = response?.pushNotificationAppID;
    if(this.pushNotificationConfig.oneSignalAppId && this.pushNotificationConfig.firebaseProjectNumber) {
      this.pushNotificationsService.initializeOneSignal(this.pushNotificationConfig.oneSignalAppId, this.pushNotificationConfig.firebaseProjectNumber);
    }
  }

  public setCompany(response: any) {
    this.Company = response;
  }
  public get getCompanyGroup(): CompanyGroupResponse {
    const companyData = localStorage.getItem('COMPANY_DATA');
    if (companyData) {
      const company = JSON.parse(companyData);
      setTimeout(() => {
        const htmlEl = document.querySelector('html');
        htmlEl.style.setProperty('--ion-color-primary', company.primaryColour);
        htmlEl.style.setProperty('--ion-color-secondary', company.secondaryColour);
      }, 0);
      return company;
    }
    return null;
  }
}
